export default "{\n    \"label\": \"Sensor\",\n    \"options\": {\n        \"true\": \"Tiene sensor\"\n    }\n}\n"